import { render, staticRenderFns } from "./DownPaymentForm.vue?vue&type=template&id=74684cd7&scoped=true"
import script from "./DownPaymentForm.vue?vue&type=script&lang=js"
export * from "./DownPaymentForm.vue?vue&type=script&lang=js"
import style0 from "./DownPaymentForm.vue?vue&type=style&index=0&id=74684cd7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74684cd7",
  null
  
)

export default component.exports